"use client";

import { c as _c } from "react/compiler-runtime";
import cn from "classnames";
import { format } from "date-fns";
import SelectedDateTransition from "src/components/programdatebutton/SelectedDateTransition";
import { locale } from "src/lib/locale/date-fns";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import styles from "./ProgramDateButton.module.css";

//#region [Props]
type ProgramDateButtonProps = {
  date: Date;
  className?: string;
  isSelected?: boolean | null;
  onClick?: (date: Date) => void;
  ref?: React.Ref<HTMLButtonElement>;
};
//#endregion

//#region [Component]
export default function ProgramDateButton(t0) {
  const $ = _c(38);
  const {
    date,
    className,
    isSelected,
    onClick,
    ref
  } = t0;
  let t1;
  let t2;
  if ($[0] !== className || $[1] !== isSelected || $[2] !== ref) {
    const themeStyles = getThemeStyles(styles, {
      [styles.isSelected]: isSelected
    });
    t1 = ref;
    t2 = cn(styles.ProgramDateButton, themeStyles, className);
    $[0] = className;
    $[1] = isSelected;
    $[2] = ref;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== date || $[6] !== onClick) {
    t3 = onClick ? () => onClick(date) : undefined;
    $[5] = date;
    $[6] = onClick;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = !!isSelected;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn(styles.DayOfWeek, "DayOfWeek");
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== date) {
    t6 = format(date, "EEEE", {
      locale
    });
    $[9] = date;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn(styles.Date, "Date");
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== date) {
    t9 = format(date, "dd.", {
      locale
    });
    $[14] = date;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t9) {
    t10 = <span className={t8}>{t9}</span>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = cn(styles.Month, "Month");
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== date) {
    t12 = format(date, "MMM", {
      locale
    });
    $[19] = date;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <span className={t11}>{t12}</span>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t10 || $[24] !== t13) {
    t14 = <div className={styles.DateContainer}>{t10}{t13}</div>;
    $[23] = t10;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t14 || $[27] !== t7) {
    t15 = <div className={styles.BorderContainer}>{t7}{t14}</div>;
    $[26] = t14;
    $[27] = t7;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== isSelected || $[30] !== t15) {
    t16 = <SelectedDateTransition isSelected={isSelected}>{t15}</SelectedDateTransition>;
    $[29] = isSelected;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t1 || $[33] !== t16 || $[34] !== t2 || $[35] !== t3 || $[36] !== t4) {
    t17 = <button ref={t1} className={t2} onClick={t3} disabled={t4}>{t16}</button>;
    $[32] = t1;
    $[33] = t16;
    $[34] = t2;
    $[35] = t3;
    $[36] = t4;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  return t17;
}
//#endregion